module.exports = __webpack_public_path__ + "img/naoris.e8d95094.svg";